import domready from "domready"
import { PerspectiveCamera, Vector3, Matrix4, Frustum, WebGLRenderer } from "three"
import "./style.css"

const PHI = (1 + Math.sqrt(5)) / 2;
const TAU = Math.PI * 2;
const DEG2RAD_FACTOR = TAU / 360;

const config = {
    width: 0,
    height: 0
};

/**
 * @type CanvasRenderingContext2D
 */
let ctx;
let canvas;


function randomAngle(count = 24)
{
    return TAU / count * Math.floor(Math.random() * count)
}


const ORIGIN = new Vector3(0,0,0)

function drawCube(projScreenMatrix, offset = ORIGIN)
{
    const { width, height} = config
    const cx = width >> 1
    const cy = height >> 1


    const f = 300
    const coords = [
        new Vector3(1, 1, 1),
        new Vector3(1, -1, 1),
        new Vector3(-1, -1, 1),
        new Vector3(-1, 1, 1),
        new Vector3(1, 1, -1),
        new Vector3(1, -1, -1),
        new Vector3(-1, -1, -1),
        new Vector3(-1, 1, -1),
    ]

    const faces = [
        [0, 1, 2, 3],
        [4, 5, 1, 0],
        [7, 6, 5, 4],
        [3, 2, 6, 7],
        [3, 7, 4, 0],
        [2, 1, 5, 6],
    ]

    for (let i = 0; i < faces.length; i++)
    {

        const points = faces[i].map(n => {
            return coords[n].clone().add(offset).applyMatrix4(projScreenMatrix)
        })

        const aspect = width / height

        const pt = points[points.length - 1]
        const x = cx + pt.x * f * aspect / pt.z
        const y = cy - pt.y * f / pt.z
        ctx.beginPath()
        ctx.moveTo(x, y)
        for (let j = 0; j < points.length; j++)
        {
            const pt = points[j]
            const x = cx + pt.x * aspect * f / pt.z
            const y = cy - pt.y * f / pt.z
            ctx.lineTo(x, y)
        }
        ctx.fill()
        ctx.stroke()
    }
}


domready(
    () => {

        canvas = document.getElementById("screen");
        ctx = canvas.getContext("2d");

        const width = (window.innerWidth) | 0;
        const height = (window.innerHeight) | 0;

        config.width = width;
        config.height = height;

        canvas.width = width;
        canvas.height = height;

        const cx = width >> 1
        const cy = height >> 1


        const camera = new PerspectiveCamera(60, width / height, 0.1, 1000)

        const paint = () => {

            const camDist = 6
            const camHeight = camDist/4

            let angle = randomAngle()

            const animate = () => {

                camera.position.set(
                    Math.cos(angle) * camDist,
                    camHeight * 3,
                    Math.sin(angle) * camDist,
                )
                camera.lookAt(0,0,0)
                camera.updateMatrix()
                camera.updateProjectionMatrix()
                camera.updateWorldMatrix()


                const projScreenMatrix = new Matrix4()
                projScreenMatrix.multiplyMatrices( camera.projectionMatrix, camera.matrixWorldInverse );

                ctx.fillStyle = "#000";
                ctx.fillRect(0,0, width, height);

                ctx.strokeStyle = "#0c0";
                drawCube(projScreenMatrix)
                drawCube(projScreenMatrix, new Vector3(3,0,0))
                drawCube(projScreenMatrix, new Vector3(0,3,0))
                drawCube(projScreenMatrix, new Vector3(0,0,3))
                drawCube(projScreenMatrix, new Vector3(-3,0,0))
                drawCube(projScreenMatrix, new Vector3(0,0,-3))

                angle += 0.01

                requestAnimationFrame(animate)

            }
            requestAnimationFrame(animate)
        }

        paint()

        canvas.addEventListener("click", paint, true)
    }
);
